  import React, { useState, useEffect } from "react";
  import axios from "axios";
  import "./BulletinBoard.css";

  const BulletinBoard = () => {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);


    const [showAddForm, setShowAddForm] = useState(false);
    const [newContent, setNewContent] = useState("");
    const [newLink, setNewLink] = useState("");
    const [isNew, setIsNew] = useState(0);


    const [showConfirm, setShowConfirm] = useState(false);


    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [deleteId, setDeleteId] = useState(null);


    const [editingId, setEditingId] = useState(null);
    const [editContent, setEditContent] = useState("");
    const [editLink, setEditLink] = useState("");
    const [editIsNew, setEditIsNew] = useState(0);
    // const [stage, setStage] = useState(1);

    const [editStage, setEditStage] = useState(1);

    useEffect(() => {
      fetchEvents();
    }, []);

    const fetchEvents = async () => {
      try {
        const res = await axios.get("/backend/bulletin");
        setEvents(res.data);
        setEditingId(null);
        setEditContent("");
        setEditLink("");
        setEditIsNew(0);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    const handleAddEvent = async () => {
  try {
    await axios.post("/backend/bulletin", {
      content: newContent,
      link: newLink,
      is_new: isNew,
      stage: editStage, 
    });

    fetchEvents();

    setShowAddForm(false);
    setShowConfirm(false);
    setNewContent("");
    setNewLink("");
    setIsNew(0);
  } catch (err) {
    console.error(err);
  }
};


   const handleDelete = async () => {
  try {
    await axios.delete(`/backend/bulletin/${deleteId}`);

    setEvents(events.filter((e) => e.id !== deleteId));
    setShowDeleteConfirm(false);
    setDeleteId(null);
  } catch (err) {
    console.error(err);
  }
};



    const handleUpdate = async (id) => {
  await axios.patch(`/backend/bulletin/${id}`, {
    content: editContent,
    link: editLink,
    is_new: editIsNew,
    stage: editStage, 
  });

  setEvents(
    events.map((e) =>
      e.id === id
        ? {
            ...e,
            content: editContent,
            link: editLink,
            is_new: editIsNew,
            stage: 1,
          }
        : e
    )
  );

  setEditingId(null);
};

// const toggleStage = async (id, value) => {
//   try {
//     await axios.patch(`/backend/bulletin/${id}`, {
//       stage: value,
//     });

//     setEvents((prev) =>
//       prev.map((e) =>
//         e.id === id ? { ...e, stage: value } : e
//       )
//     );
//   } catch (err) {
//     console.error(err);
//   }
// };

    if (loading) return <h2 style={{ textAlign: "center" }}>Loading...</h2>;

    return (
      <div className="bulletinboard_bulletins-page">
        <div className="bulletinboard_admins-wrapper">

          {/* HEADER */}
          <div className="bulletinboard_admins_bulletin-header">
            <div className="bulletinboard_headers-left">
              <h1>Bulletin Dashboard</h1>
            </div>

            <button
              className="bulletinboard_adds-btn-top"
              onClick={() => setShowAddForm(true)}
            >
              + Add Event
            </button>
          </div>

          {/* TABLE */}
          <div className="bulletinboard_tables-container">
            <table className="bulletinboard_dashboards-table">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Content</th>
                  <th>Link</th>
                  <th>New</th>
                  {/* <th>Stage</th> */}
                  <th>Actions</th>
                  
                </tr>
              </thead>

              <tbody>
                {console.log(events," ",typeof(events))}
                {events.map((event, index) => (

                  <tr key={event.id}>
                    <td>{index + 1}</td>

                    {editingId === event.id ? (
                      <>
                        <td>
                          <input
                            value={editContent}
                            onChange={(e) => setEditContent(e.target.value)}
                          />
                        </td>

                        <td>
                          <input
                            value={editLink}
                            onChange={(e) => setEditLink(e.target.value)}
                          />
                        </td>

                        <td>
                          <label className="bulletinboard_check">
                            <input type="checkbox"
                              checked={editIsNew === 1}
                              onChange={(e) => setEditIsNew(e.target.checked ? 1 : 0)}
                            />
                            <span>Is New</span>
                          </label>

                        </td>
                       

                        <td className="bulletinboard_actionss">
                             <label className="bulletinboard_check">
    <input
      type="checkbox"
      checked={editStage === 1}
      onChange={(e) =>
        setEditStage(e.target.checked ? 1 : 0)
      }
    />
    <span>
      {editStage === 1 ? "Active" : "Hidden"}
    </span>
  </label>
                          <button className="bulletinboard_btns save" onClick={() => handleUpdate(event.id)}>
                            Save
                          </button>
                          <button className="bulletinboard_btns cancel" onClick={() => setEditingId(null)}>
                            Cancel
                          </button>
                        </td>
                      </>
                    ) : (
                      <>
                       <td className="bulletinboard_text-wrap">
  {event.content}
</td>

                        <td className="bulletinboard_text-wrap">
  <a
    href={event.link}
    target="_blank"
    rel="noreferrer"
    className="bulletinboard_text-wrap"
  >
    {event.link}
  </a>
</td>

                        <td>
                          {event.is_new === 1 && <span className="bulletinboard_badge">NEW</span>}
                        </td>
                        {/* <td>
  <label className="bulletinboard_check">
    <input
      type="checkbox"
      checked={event.stage === 1}
      onChange={(e) =>
        toggleStage(
          event.id,
          e.target.checked ? 1 : 0
        )
      }
    />
    <span>
      {event.stage === 1 ? "Active" : "Hidden"}
    </span>
  </label>
</td> */}

                        <td className="bulletinboard_actionss">
                          <button
                            className="bulletinboard_btns edit"
                            onClick={() => {
                              setEditingId(event.id);
                              setEditContent(event.content);
                              setEditLink(event.link);
                              setEditIsNew(event.is_new);
                               setEditStage(event.stage);
                            }}
                          >
                            Edit
                          </button>

                         
                          <button
                            className="bulletinboard_btns delete"
                            onClick={() => {
                              setDeleteId(event.id);
                              setShowDeleteConfirm(true);
                            }}
                          >
                            Delete
                          </button>
                        </td>
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* ADD MODAL */}
          {showAddForm && (
            <div className="bulletinboard_modals">
              <div className="bulletinboard_modals-box">
                <h2>Add Event</h2>

                <textarea
                  placeholder="Content"
                  value={newContent}
                  onChange={(e) => setNewContent(e.target.value)}
                />

                <textarea
                  placeholder="Link"
                  value={newLink}
                  onChange={(e) => setNewLink(e.target.value)}
                />

                <label className="bulletinboard_checkboxs">
                  <input
                    type="checkbox"
                    checked={isNew === 1}
                    onChange={(e) => setIsNew(e.target.checked ? 1 : 0)}
                  />
                  &nbsp; Is New
                </label>

                <div className="bulletinboard_actionss">
                  <button
                    className="bulletinboard_btns save"
                    onClick={() => {
                      if (!newContent || !newLink) {
                        alert("Fill all fields");
                        return;
                      }
                      setShowConfirm(true);
                    }}
                  >
                    Add
                  </button>
                  <button className="bulletinboard_btns cancel" onClick={() => setShowAddForm(false)}>
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}

         
          {showConfirm && (
            <div className="bulletinboard_modals">
              <div className="bulletinboard_modals-box">
                <h2>Confirm Event</h2>

                <p><b>Content:</b> {newContent}</p>
                <p><b>Link:</b> {newLink}</p>
                <p><b>Status:</b> {isNew === 1 ? "NEW" : "Normal"}</p>

                <div className="bulletinboard_actionss">
                  <button className="bulletinboard_btns save" onClick={handleAddEvent}>
                    Confirm
                  </button>
                  <button className="bulletinboard_btns cancel" onClick={() => setShowConfirm(false)}>
                    Cancel
                  </button>
                  
                </div>
              </div>
            </div>
          )}

          
          {showDeleteConfirm && (
            <div className="bulletinboard_modals">
              <div className="bulletinboard_modals-box">
                <h2>Confirm Delete</h2>
                <p>Are you sure you want to delete this event?</p>

                <div className="bulletinboard_actionss">
                  <button className="bulletinboard_btns save" onClick={handleDelete}>
                    Delete
                  </button>
                  <button
                    className="bulletinboard_btns cancel"
                    onClick={() => setShowDeleteConfirm(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}

        </div>
      </div>
    );
  };

  export default BulletinBoard;
